import React, { useState } from 'react'
import { useTranslation } from "react-i18next";
import PropTypes from 'prop-types';
import { Card } from 'react-bootstrap';
import ReactApexChart from 'react-apexcharts';

function StackedChart(props) {
    const { t } = useTranslation();

    const {
        inputParam_DataserieChartItem = null,
    } = props;
    
    const [dataserie, setDataserie] = useState({
        series: [
            {
                name: 'nDataserieValues',
                data: inputParam_DataserieChartItem.map(item => item.nDataserieValues),
            },
        ],
        options: {
            chart: {
                type: 'bar',
            },
            xaxis: {
                categories: inputParam_DataserieChartItem.map(item => item.periodoId.toString()),
            },
        },
    })

    return (
        <>
            <Card className='mb-1'>
                <Card.Header className="card-header-compact">
                    <Card.Title className="d-flex justify-content-between">
                        <b>{t('data-lang-boxname-homechartbar')}</b>
                    </Card.Title>
                </Card.Header>
                <Card.Footer style={{padding: "0px", borderBottom: "1px solid rgba(0, 0, 0, 0.125)"}}>
                    <div className='book-toolbar d-flex float-end'>
                    </div>
                </Card.Footer>
                <Card.Body className="h-100">
                    <div>
                        <ReactApexChart options={dataserie.options} series={dataserie.series} type="bar" height={350} />
                    </div>
                </Card.Body>
            </Card>
        </>
    );
}

StackedChart.propTypes = {
    inputParam_DataserieChartItem: PropTypes.array.isRequired,
    inputParam_VariableName: PropTypes.string,
};

export default StackedChart;